import type { CSSProperties, ReactNode } from "react";

export function Badge({ children }: { children?: ReactNode }) {
  const style: CSSProperties = {
    display: "inline-block",
    padding: "1px 6px",
    borderRadius: "6px",
    fontSize: "0.8em",
    fontWeight: 600,
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
    color: "var(--secondary)",
    backgroundColor: "var(--primary)",
    whiteSpace: "nowrap",
  };
  return <span style={style}>{children}</span>;
}